<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-3 p-ml-5 p-mr-5 p-mb-3">
        <div class="p-formgrid p-grid p-justify-center">
          <div class="p-field p-col-12 p-lg-4 p-mt-2">
            <label for="organizeOptions">{{ $t("organize_name") }}</label>
            <Dropdown
              v-model.lazy="organizeSelected"
              :options="organizeOptions"
              optionLabel="organize_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="organizeOptions">
                <div v-if="organizeOptions.value">
                  <div>{{ organizeOptions.value.organize_name }}</div>
                </div>
                <span v-else>
                  {{ organizeOptions.placeholder }}
                </span>
              </template>
              <template #option="organizeOptions">
                <div>{{ organizeOptions.option.organize_name }}</div>
              </template>
            </Dropdown>
          </div>

          <div class="p-field p-col-12 p-lg-2 p-mt-2">
            <label for="searchYearStart">{{ $t("searchYearStart") }}</label>
            <InputNumber
              id="searchYearStart"
              v-model="searchYearStart"
              :max="searchYearEnd"
              :useGrouping="false"
              :class="{
                'p-invalid':
                  (error_searchYearStart && !searchYearStart) ||
                  error_format_year_s == true,
              }"
            />
            <small
              class="p-invalid"
              v-if="error_searchYearStart && !searchYearStart"
              >{{ $t("searchYearStart_validate") }}</small
            >
            <small class="p-invalid" v-if="error_format_year_s == true">{{
              $t("is_year_add_format_validate")
            }}</small>
          </div>

          <div class="p-field p-col-12 p-lg-2 p-mt-2">
            <label for="searchYearEnd">{{ $t("searchYearEnd") }}</label>
            <InputNumber
              id="searchYearEnd"
              v-model="searchYearEnd"
              :min="searchYearStart"
              :useGrouping="false"
              :class="{
                'p-invalid':
                  (error_searchYearEnd && !searchYearEnd) ||
                  error_format_year_e == true,
              }"
            />
            <small
              class="p-invalid"
              v-if="error_searchYearEnd && !searchYearEnd"
              >{{ $t("searchYearEnd_validate") }}</small
            >
            <small class="p-invalid" v-if="error_format_year_e == true">{{
              $t("is_year_add_format_validate")
            }}</small>
          </div>

          <div class="p-field p-col p-mt-2">
            <div class="p-formgrid p-grid p-jc-end p-mt-5">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-ml-3 p-mr-3"
              />
              <Button
                @click="statisticData()"
                :label="$t('searchBtn')"
                class="p-button-info"
              />
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="statistic_table"
        :paginator="true"
        :rows="10"
        :scrollable="true"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <Column
          field="organize_name"
          :header="$t('organize_name')"
          :sortable="true"
          headerStyle="width: 300px"
        >
          <template #body="slotProps">
            <span style="font-weight: 700" >
              <i v-if="checkEdit_data != 'false'"
                class="pi pi-pencil pointer"
                style="color: #ecad0e; margin-right: 10px"
                @click="
                  statisticModal = true;
                  editData(slotProps.data.statistic_id);
                  temp = slotProps.data.statistic_id;
                "
              ></i>
              {{ slotProps.data.organize_name }}
            </span>
          </template>
        </Column>
        <div v-for="years in year_header" :key="year_header.indexOf(years)">
          <Column :header="years.toString()" headerStyle="width: 100px">
            <template #body="slotProps">
              <div v-if="slotProps.data.year == '[]'">&nbsp;</div>
              <div v-else>
                <div
                  v-for="year in JSON.parse(slotProps.data.year)"
                  :key="year.year"
                >
                  <div v-if="year.year == years.toString()">
                    {{ year.number }}
                  </div>
                </div>
              </div>
            </template>
          </Column>
        </div>
      </DataTable>
    </div>

    <!-- Manage modal -->
    <Dialog
      :modal="true"
      :visible.sync="statisticModal"
      :style="{ width: '600px' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :header="header"
    >
      <div class="confirmation-content">
        <label>{{ $t("is_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <!-- <div v-if="disabled == false" class="p-field p-col-12">
            <label for="is_organize_code" v-if="disabled == false">{{ $t("is_organize_code") }}</label>
            <InputText
              v-if="disabled == false"
              id="is_organize_code"
              type="text"
              v-model="is_organize_code"
              disabled
            />
          </div> -->
          <div class="p-field p-col-12 p-mb-3">
            <label for="is_organize_name">{{ $t("is_organize_name") }}</label>
            <InputText
              id="is_organize_name"
              type="text"
              v-model="is_organize_name"
              disabled
            />
          </div>

          <span @click="showAddList = !showAddList" class="p-col-12 pointer"
            ><u><i :class="icon"></i> {{ $t("is_add_list") }}</u></span
          >
          <div class="p-fluid" v-if="showAddList">
            <div class="p-formgrid p-grid p-col-12 p-justify-center">
              <div class="p-field p-col-12 p-lg-4 p-mt-2">
                <label for="is_year_add">{{ $t("is_year") }}</label>
                <InputNumber
                  :max="9999"
                  :min="0"
                  :maxlength="4"
                  :disabled="is_year_addDisabled == 1"
                  id="is_year_add"
                  v-model="is_year_add"
                  showButtons
                  :useGrouping="false"
                  :class="{
                    'p-invalid':
                      error_duplicated_year == true ||
                      error_format_year == true ||
                      error_add_statistic == true,
                  }"
                />
              </div>
              <div class="p-field p-col-12 p-lg-4 p-mt-2">
                <label for="is_organize_code">{{ $t("is_population") }}</label>
                <InputNumber
                  id="is_population_add"
                  v-model="is_population_add"
                  showButtons
                  :min="0"
                  :class="{ 'p-invalid': error_add_statistic == true }"
                />
              </div>
              <div class="p-field p-col">
                <div class="p-field p-col p-mt-5">
                  <Button
                    @click="checkDuplicatedYear()"
                    icon="pi pi-check"
                    class="p-button-rounded p-button-success p-mr-2"
                  />
                  <Button
                    @click="clearSubData()"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-secondary"
                  />
                </div>
              </div>
            </div>
            <small
              class="p-invalid p-ml-5"
              v-if="error_duplicated_year == true"
              >{{ $t("is_year_add_validate") }}</small
            >
            <small class="p-invalid p-ml-5" v-if="error_format_year == true">{{
              $t("is_year_add_format_validate")
            }}</small>
          </div>
          <small class="p-invalid p-ml-5" v-if="error_add_statistic == true"
            >กรุณาระบุข้อมูลให้ครบถ้วน</small
          >

          <div class="p-formgrid p-grid p-mt-3">
            <DataTable
              :value="statisticSpecific_table"
              :paginator="true"
              :rows="5"
              sortField="year"
              :sortOrder="1"
              dataKey="id"
              :rowHover="true"
             
              selectionMode="single"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[5, 10, 20, 50]"
              currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
              <template #empty>{{ $t("TableEmpty") }}</template>
              <Column field="year" :header="$t('is_year')" :sortable="true">
                <template #body="dataTable">
                  {{ dataTable.data.year }}
                </template>
              </Column>
              <Column
                field="number"
                :header="$t('is_population')"
                :sortable="true"
              >
                <template #body="dataTable">
                  {{ dataTable.data.number }}
                </template>
              </Column>
              <Column :header="$t('controlTable')">
                <template #body="dataTable">
                  <div class="p-formgrid p-grid">
                    <div class="p-field p-col">
                      <Button
                        @click="
                          editSubData(dataTable.data);
                          saveAt = 'edit-subdata';
                        "
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-warning p-mr-3"
                      />
                      <Button
                        v-if="statistic_disable == false"
                        @click="
                          displayConfirmation = true;
                          year = dataTable.data;
                        "
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-danger"
                      />
                    </div>
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dropdownClearFilerValue:0,
      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,

      organizeOptions: [],
      organizeSelected: null,
      selected: null,
      statistic_table: [],
      statisticSpecific_table: [],
      filters: {},
      temp: null,
      year: {},
      displayConfirmation: false,
      statisticModal: false,
      header: this.$i18n.t("is_modal_title"),
      selectedData: "",
      is_organize_code: "",
      is_organize_name: "",
      error_is_year: false,
      error_is_population: false,

      showAddList: false,
      icon: "pi pi-plus",
      is_year_add: null,
      is_population_add: 0,

      year_header: [],
      error_duplicated_year: false,
      error_format_year: false,

      is_year_addDisabled: 1,
      saveAt: "",
      editAt: {},

      searchYearEnd: null,
      searchYearStart: null,

      error_searchYearStart: false,
      error_searchYearEnd: false,

      error_format_year_s: false,
      error_format_year_e: false,

      error_add_statistic: false,

      statistic_disable: true,

      loading:false,
    };
  },
  watch: {
    statisticModal(val) {
      if (val == false) {
        this.clearData();
      }
    },

    showAddList(val) {
      if (val == true) {
        this.icon = "pi pi-minus";
      } else {
        this.icon = "pi pi-plus";
      }
    },

    selectedData(val) {
      if (val != "") {
        this.statisticSpecific_table = JSON.parse(val.year);
      }
    },

    async organizeSelected(val) {
      if (val == null) {
        this.initialData()
      }
    },

    saveAt(val) {
      if (val == "") {
        this.is_year_addDisabled = 0;
      } else {
        this.is_year_addDisabled = 1;
      }
    },

    year_header(val) {
      if (val.length == 0) {
        this.setNewHeader();
      }
    },
  },
  async created() {
    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;  

    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `);

    this.is_year_addDisabled = 0;
	this.initialData()
	this.defaultYear();
 
    await this.axios
      .post(`${this.$url_service}/initial/organize`, {
        body: {
          topic: "get-option",
          userOrg: this.checkPermission() ? null : this.getUserOrganize(),
        },
      })
      .then((response) => {
        (this.organizeOptions = response.data.data),
          this.organizeOptions.splice(0, 0, {
            organize_id: "getall",
            organize_name: this.$i18n.t("selectAll"),
          });
      });
  
  },
  mounted() {},
  methods: {
    async initialData() {

      let temporary = localStorage.getItem("username");
      if ((temporary.toString().indexOf("manage03") != -1) || temporary.toString().indexOf("manage032") != -1) {
        this.statistic_disable = false;
      } else {
        this.statistic_disable = true;
      }
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/get/population`, {
          body: {
            topic: "get-main-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => (this.statistic_table = response.data.data));
        this.loading = false;
    },

    defaultYear() {
      var year = new Date().getFullYear();
      for (let i = 0; i < 5; i++) {
        this.year_header.push([`${year + 543 - i}`]);
      }
      this.year_header.reverse();
    },

    confirmDelete() {
      this.displayConfirmation = false;
      this.statisticSpecific_table = this.statisticSpecific_table.filter(
        (val) => val !== this.year
      );
      // this.$toast.add({
      //   severity: "success",
      //   summary: "ลบข้อมูลสถิติประชากรเสร็จสิ้น",
      //   detail: `ปี ${this.year.year}`,
      //   life: 3000,
      // });
      this.$fire({
              title: "ลบข้อมูลสถิติประชากรเสร็จสิ้น",
              text: `ปี ${this.year.year}`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
    },

    async statisticData() {
      if (this.searchYearStart == null && this.searchYearEnd == null) {
        this.loading = true;
        await this.axios
          .post(`${this.$url_service}/get/population`, {
            body: {
              topic: "search-table",
              userOrg: this.checkPermission() ? null : this.getUserOrganize(),
              organize: this.organizeSelected,
            },
          })
          .then((response) => (this.statistic_table = response.data.data));
          this.loading = false;
      } else if (this.searchYearStart == null || this.searchYearEnd == null) {
        if (this.searchYearStart == null) {
          this.error_searchYearStart = true;
        }
        if (this.searchYearEnd == null) {
          this.error_searchYearEnd = true;
        }
      } else {
        if (
          String(this.searchYearStart).length != 4 ||
          String(this.searchYearEnd).length != 4
        ) {
          if (String(this.searchYearStart).length != 4) {
            this.error_format_year_s = true;
          } else {
            this.error_format_year_s = false;
          }
          if (String(this.searchYearEnd).length != 4) {
            this.error_format_year_e = true;
          } else {
            this.error_format_year_e = false;
          }
        } else {
          this.statistic_table = [];
          this.year_header = [];
          this.error_format_year_s = false;
          this.error_format_year_e = false;
        }
      }
    },

    async setNewHeader() {
      if (this.searchYearStart == this.searchYearEnd) {
        this.year_header.push([`${this.searchYearStart}`]);
      } else {
        var startY = Number(this.searchYearStart);
        var endY = Number(this.searchYearEnd);
        var diff_year = endY - startY - 1;
        if (diff_year == 0) {
          this.year_header.push([`${this.searchYearStart}`]);
          this.year_header.push([`${this.searchYearEnd}`]);
        } else {
          var year_range = [this.searchYearStart, this.searchYearEnd];
          for (let i = 0; i < diff_year; i++) {
            var check = `${Number(year_range[i]) + 1}`;
            year_range.splice(i + 1, 0, check);
          }
          // console.log(year_range);
          this.year_header.push([`${this.searchYearStart}`]);
          for (let j = 1; j < year_range.length - 1; j++) {
            this.year_header.push([`${year_range[j]}`]);
          }
          this.year_header.push([`${this.searchYearEnd}`]);
        }
      }

      await this.axios
        .post(`${this.$url_service}/get/population`, {
          body: {
            topic: "search-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            organize: this.organizeSelected,
          },
        })
        .then((response) => (this.statistic_table = response.data.data));
    },

    async saveData() {
      this.statisticModal = false;
      await this.axios
        .post(`${this.$url_service}/get/population`, {
          body: {
            topic: "add-new-stat",
            id: this.temp,
            data: this.statisticSpecific_table,
          },
        })
        .then(() => {
          // (this.initialData())
          this.statisticData()

        });
      // this.$toast.add({
      //   severity: "success",
      //   summary: "แก้ไขข้อมูลสถิติประชากรเสร็จสิ้น",
      //   detail: `หน่วยงาน ${this.is_organize_name}`,
      //   life: 3000,
      // });
      this.$fire({
              title: "แก้ไขข้อมูลสถิติประชากรเสร็จสิ้น",
              text: `หน่วยงาน ${this.is_organize_name}`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      this.clearData();
    },

    async editData(data) {
      await this.axios
        .post(`${this.$url_service}/get/population`, {
          body: {
            topic: "get-sub-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            id: data,
          },
        })
        .then((response) => {
          (this.selectedData = response.data.data),
            (this.is_organize_code = response.data.data.organize_code),
            (this.is_organize_name = response.data.data.organize_name);
        });
    },

    editSubData(data) {
      this.showAddList = true;
      this.is_year_add = Number(data.year);
      this.is_population_add = Number(data.number);
      this.editAt = data;
    },

    checkDuplicatedYear() {
      if (this.saveAt != "") {
        this.statisticSpecific_table = this.statisticSpecific_table.filter(
          (val) => val !== this.editAt
        );
        this.statisticSpecific_table.push({
          year: this.is_year_add,
          number: this.is_population_add,
        });
        // this.$toast.add({
        //   severity: "success",
        //   summary: "แก้ไขข้อมูลสถิติประชากรเสร็จสิ้น",
        //   detail: `ปี ${this.is_year_add}`,
        //   life: 3000,
        // });
        this.$fire({
              title: "แก้ไขข้อมูลสถิติประชากรเสร็จสิ้น",
              text: `ปี ${this.is_year_add}`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
        this.showAddList = false;
        this.is_year_add = null;
        this.is_population_add = 0;
        this.saveAt = "";
      } else {
        if (this.is_year_add != null && this.is_population_add != 0) {
          this.error_add_statistic = false;
          if (this.statisticSpecific_table.length == 0) {
            this.saveNewList();
          } else {
            for (let i = 0; i < this.statisticSpecific_table.length; i++) {
              const found = this.statisticSpecific_table.find(
                (x) => x.year == `${this.is_year_add}`
              );
              if (found == undefined) {
                i = this.statisticSpecific_table.length;
                this.error_duplicated_year = false;
                this.saveNewList();
              } else {
                this.error_duplicated_year = true;
                this.error_format_year = false;
              }
            }
          }
        } else {
          this.error_add_statistic = true;
        }
      }
    },

    saveNewList() {
      if (this.error_duplicated_year == false) {
        if (String(this.is_year_add).length == 4) {
          this.error_format_year = false;
          if (this.is_population_add == null) {
            this.is_population_add = 0;
          }
          this.statisticSpecific_table.push({
            year: this.is_year_add,
            number: this.is_population_add,
          });
          // this.$toast.add({
          //   severity: "success",
          //   summary: "เพิ่มข้อมูลสถิติประชากรเสร็จสิ้น",
          //   detail: `ปี ${this.is_year_add}`,
          //   life: 3000,
          // });
            this.$fire({
              title: "เพิ่มข้อมูลสถิติประชากรเสร็จสิ้น",
              text: `ปี ${this.is_year_add}`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          this.is_year_add = null;
          this.is_population_add = 0;
        } else {
          this.error_format_year = true;
        }
      }
    },

    clearData() {
      this.temp = null;
      this.displayConfirmation = false;
      this.statisticModal = false;
      this.selectedData = "";
      this.showAddList = false;
      this.error_duplicated_year = false;
      this.clearSubData();
    },

    clearSubData() {
      this.is_year_add = null;
      this.is_population_add = 0;
      this.saveAt = "";
    },

    async clearSearchField() {
      this.dropdownClearFilerValue +=1;
      this.organizeSelected = null;
      this.searchYearStart = null;
      this.searchYearEnd = null;
      this.year_header = [];
      this.defaultYear();
      this.initialData()
    },
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>
